'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPropTypes = exports.Field = exports.connectForm = exports.selectors = exports.reducer = exports.actions = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        Reducer as default export is deprecated and will be removed in 1.0.0.\n        Refer to README.md for proper usage of the module.\n      '], ['\n        Reducer as default export is deprecated and will be removed in 1.0.0.\n        Refer to README.md for proper usage of the module.\n      ']);

var _connectForm = require('./connectForm');

Object.defineProperty(exports, 'connectForm', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectForm).default;
  }
});

var _Field = require('./Field');

Object.defineProperty(exports, 'Field', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Field).default;
  }
});

var _FormPropTypes = require('./FormPropTypes');

Object.defineProperty(exports, 'FormPropTypes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormPropTypes).default;
  }
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _commonTags = require('common-tags');

var tags = _interopRequireWildcard(_commonTags);

var _forms = require('./forms');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultImportDeprecationNotice = R.once(function () {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(tags.oneLine(_templateObject));
  }
});

exports.default = function (state, action) {
  defaultImportDeprecationNotice();
  return (0, _forms.reducer)(state, action);
};

_forms.reducer.actions = _forms.actions;
_forms.reducer.selectors = _forms.selectors;

exports.actions = _forms.actions;
exports.reducer = _forms.reducer;
exports.selectors = _forms.selectors;